module.exports = __webpack_public_path__ + "svg_80x80/csharp.9cee77.svg";